import React from "react";

const Title = ({
  id,
  text,
  hasSubsections = false,
  totalItems = 0,
  issueTypeRecord = {},
  placedAt = "",
  hasProfileImage: profileImageUrl = false,
}) => {
  return (
    <div
      id={`section-${text ? text.toLowerCase().replace(/\s+/g, "-") : "untitled"}`}
      className="title-wrapper text-center"
    >
      <div id={id} className="title">
        <div className={placedAt === "drawer" ? "drawer-title" : ""}>
          {profileImageUrl ? (
            <img
              src={profileImageUrl}
              alt="profile"
              className="profile-image"
              style={{
                width: "100%",
                height: "auto",
              }}
            />
          ) : (
            <span>{text}</span>
          )}
        </div>
        {!hasSubsections && placedAt === "itemSection" && (
          <div className="d-flex align-items-center" style={{ gap: "8px" }}>
            {/* <div>
              {issueTypeRecord.hazard > 0 ? (
                <Circle type="concern-hazard" />
              ) : null}
              {issueTypeRecord.recommendation > 0 ? (
                <Circle type="concern-recommendation" />
              ) : null}
              {issueTypeRecord.maintenance > 0 ? (
                <Circle type="concern-maintenance" />
              ) : null}
            </div> */}
            <span className="total-items">
              {totalItems} item{totalItems > 1 ? "s" : ""}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default Title;
